import Vue from 'vue'
import Router from 'vue-router'
import User from '@/router/modules/user'

Vue.use(Router)

let routes=[
    User,
    {
        path:'/login',
        name:'login',
        component:()=>import('@/views/login'),
        meta:{
            title:'Login',
            code:'router_login',
            keepAlive: false
        }
    },
    {
        path:'/loginTemporary',
        name:'loginTemporary',
        component:()=>import('@/views/loginTemporary'),
        meta:{
            title:'Login',
            code:'router_loginTemporary',
            keepAlive: false
        }
    },
    {
        path:'/play',
        name:'play',
        component:()=>import('@/views/play'),
        meta:{
            title:'Play',
            code:'router_play',
            keepAlive: false
        }
    },
    {
        path:'/noticeView',
        name:'noticeView',
        component:()=>import('@/views/noticeView'),
        meta:{
            title:'noticeView',
            code:'router_noticeView',
            keepAlive: false
        }
    },
    {
        path:'/demo',
        name:'demo',
        component:()=>import('@/views/demo'),
        meta:{
            title:'demo',
            code:'router_demo',
            keepAlive: false
        }
    },
    {
        path:'/error',
        name:'error',
        component:()=>import('@/views/error'),
        meta:{
            title:'error',
            code:'router_error',
            keepAlive: false
        }
    },
    {
        path:'*',
        name:'404',
        component:()=>import('@/views/404'),
        meta:{
            title:'404',
            code:'router_404',
            keepAlive: false
        }
    }
]

export default new Router({
    routes,
    mode: 'history',
    base: (process.env.NODE_ENV == 'development')?'':'',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js